import React, { useState } from 'react';
import { Box, Button, Text, SimpleGrid } from '@chakra-ui/react';

function CashierChange({ total }) {
  const [receivedCash, setReceivedCash] = useState(0);

  const denominations = [
    { value: 100, label: '100€' },
    { value: 50, label: '50€' },
    { value: 20, label: '20€' },
    { value: 10, label: '10€' },
    { value: 5, label: '5€' },
    { value: 2, label: '2€' },
    { value: 1, label: '1€' },
    { value: 0.5, label: '50¢' },
    { value: 0.2, label: '20¢' },
  ];

  const handleDenominationClick = (value) => {
    setReceivedCash((prev) => prev + value);
  };

  const handleReset = () => {
    setReceivedCash(0);
  };

  const change = receivedCash - total;
  const isInsufficient = change < 0;

  return (
    <Box mt={4} borderWidth='2px' borderColor='teal' borderRadius='md' p={4}>
      <Text fontWeight='bold' fontSize='xl' mb={4} textAlign='center'>
        Calcola Resto
      </Text>
      <SimpleGrid columns={3} spacing={2} mb={4}>
        {denominations.map((denomination) => (
          <Button
            key={denomination.value}
            onClick={() => handleDenominationClick(denomination.value)}
            size='md'
            variant='outline'
          >
            {denomination.label}
          </Button>
        ))}
      </SimpleGrid>
      
      <Box mb={2}>
        <Text as='span' fontWeight='bold' fontSize='lg'>
          Contanti Ricevuti:{' '}
        </Text>
        <Text as='span' fontWeight='bold' fontSize='lg' color='gold'>
          {receivedCash.toFixed(2)}€
        </Text>
      </Box>

      {!isInsufficient && (
        <Box mb={2}>
          <Text as='span' fontWeight='bold' fontSize='lg'>
            Resto:{' '}
          </Text>
          <Text as='span' fontWeight='bold' fontSize='lg' color='green'>
            {change.toFixed(2)}€
          </Text>
        </Box>
      )}

      <Button onClick={handleReset} size='md' variant='secondary' width='100%'>
        Azzera
      </Button>
    </Box>
  );
}

export default CashierChange;
